import { createContext, useContext } from 'react';
import { ISmartFloorPayloadUI } from '~/src/dash/apiV2/smartFloors/crud';
import { IPermissionCheck } from '~/src/dash/utils/permission_service';
import { ISmartFloorsListViewConfig } from '~/src/dash/views/bidders/Bidders/SmartFloors/SmartFloorsListView/config';
import { ISmartFloorsLiveConfig } from '~/src/dash/views/bidders/Bidders/SmartFloors/SmartFloorsLiveView/config';
import { ISmartFloorsLiveAdaptiveConfig } from '~/src/dash/views/bidders/Bidders/SmartFloors/SmartFloorsLiveAdaptiveView/config';

interface ISmartFloorsListContext {
  handlers: {
    handleSelectSiteOnChart: (siteID: number, currVal: boolean) => void;
    handleUpdateBidFloorForSmartFloor: (siteID: number, newValue: number) => void;
  };
  readAuthorization: IPermissionCheck;
  SmartFloors: {
    data: ISmartFloorPayloadUI[];
    cfg: ISmartFloorsListViewConfig;
    selectedSiteIDForSmartFloorsChart: number;
  };
  shouldAllowSortingTable: boolean;
  writeAuthorization: IPermissionCheck;
}

interface ISmartFloorsLiveContext {
  SmartFloorsStore: {
    Live: ISmartFloorsLiveConfig;
    selectedSmartFloor: ISmartFloorPayloadUI;
    selectedSiteName: string;
    selectedSiteID: number;
  };
}

interface ISmartFloorsLiveAdaptiveContext {
  liveConfig: ISmartFloorsLiveAdaptiveConfig;
  selectedSite: { ID: number; Name: string };
  selectedSmartFloor: ISmartFloorPayloadUI;
}

export const SmartFloorsListContext = createContext({} as ISmartFloorsListContext);
export const useSmartFloorsListStore = (): ISmartFloorsListContext =>
  useContext(SmartFloorsListContext);

export const SmartFloorsLiveContext = createContext({} as ISmartFloorsLiveContext);
export const useSmartFloorsLiveStore = (): ISmartFloorsLiveContext =>
  useContext(SmartFloorsLiveContext);

export const SmartFloorsLiveAdaptiveContext = createContext({} as ISmartFloorsLiveAdaptiveContext);
export const useSmartFloorsLiveAdaptiveStore = (): ISmartFloorsLiveAdaptiveContext =>
  useContext(SmartFloorsLiveAdaptiveContext);
